import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const changeDirection = (lang) => {
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.body.dir = dir;
    document.body.className = dir;
};

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        lng: 'en',
        debug: true,
        interpolation: {
            escapeValue: false,
        },
    });

i18n.on('languageChanged', changeDirection);

export default i18n;
